.leftCol {
    width: 90%;
}

.box {
    border-radius: 4px;
    padding: 1rem;
}

.blue {
    background-color: var(--ax-brand-blue-200);
}

.green {
    background-color: var(--ax-meta-lime-100);
}

.gray {
    background-color: var(--ax-neutral-200);
}

.animation {
    animation: fade-in 1s;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 100;
    }
}
